import { render, staticRenderFns } from "./PageBnA.vue?vue&type=template&id=4185433c&"
import script from "./PageBnA.vue?vue&type=script&lang=js&"
export * from "./PageBnA.vue?vue&type=script&lang=js&"
import style0 from "./PageBnA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports